export default __webpack_public_path__ + "static/media/bgvideo.db939747.mp4";